import { render, staticRenderFns } from "./newsHome.vue?vue&type=template&id=2c2c107b&scoped=true"
import script from "./newsHome.vue?vue&type=script&lang=js"
export * from "./newsHome.vue?vue&type=script&lang=js"
import style0 from "./newsHome.vue?vue&type=style&index=0&id=2c2c107b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c107b",
  null
  
)

export default component.exports